import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
    getAIRilabList(params) { //获取订单列表
        const url =  baseURL + '/tbAiriImageOptimize/getAllList';
        return axios.post(url, qs.stringify(params));
    },
    
    getAIRilabStatistics() { //查询生图统计数据
        const url =  baseURL + '/tbAiriImageOptimize/getStats';
        return axios.post(url);
    },
}



// WEBPACK FOOTER //
// ./src/api/AIRilab.js